import { render, staticRenderFns } from "./ProfitPredictor.vue?vue&type=template&id=553c7d63&scoped=true&"
import script from "./ProfitPredictor.vue?vue&type=script&lang=js&"
export * from "./ProfitPredictor.vue?vue&type=script&lang=js&"
import style0 from "./ProfitPredictor.vue?vue&type=style&index=0&id=553c7d63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553c7d63",
  null
  
)

export default component.exports